module.exports = __webpack_public_path__ + "img/patriarch.ab12e4f2.png";